import SetTariffLimitsTab from './SetTariffLimitsTab';

export default SetTariffLimitsTab;
